<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="mt-3 pb-3 card shadow-sm">
          <p class="card-header float-left">
            {{ gameInfo.player1Name }} : 得点時ラリー回数
            <span class="float-right">平均 : {{ average[1] }}</span>
          </p>
          <bar-chart :chartData="player1ChartData"
            :optionData="optionData" :height="300"/>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="mt-3 pb-3 card shadow-sm">
          <p class="card-header float-left">
            {{ gameInfo.player2Name }} : 得点時ラリー回数
            <span class="float-right">平均 : {{ average[2] }}</span>
          </p>
          <bar-chart :chartData="player2ChartData"
            :optionData="optionData" :height="300"/>
      </div>
    </div>
  </div>
</template>

<script>
import func from '@/lib/func';
import BarChart from '@/components/atoms/BarChart';

export default {
  name: 'rally-times-on-score',
  props: ['points', 'labels', 'gameInfo'],
  components: {
    BarChart,
  },
  computed: {
    player1ChartData() {
      const dataSet = this.labelData[1];
      const labelSet = [...Array(Math.max(0, ...this.labels) + 1).keys()];
      return {
        labels: labelSet,
        datasets: [
          {
            label: 'ラリー回数',
            backgroundColor: '#82B8D7',
            data: dataSet,
          },
        ],
      };
    },
    player2ChartData() {
      const dataSet = this.labelData[2];
      const labelSet = [...Array(Math.max(0, ...this.labels) + 1).keys()];
      return {
        labels: labelSet,
        datasets: [
          {
            label: 'ラリー回数',
            backgroundColor: '#83D7BD',
            data: dataSet,
          },
        ],
      };
    },
    optionData() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
          }],
        },
      };
    },
    labelData() {
      return func.getLabelData(this.points, this.labels);
    },
    average() {
      return this.getAverage(this.points, this.labels);
    },
  },
  methods: {
    getAverage(points, labels) {
      let l1 = 0;
      let l2 = 0;
      let c1 = 0;
      let c2 = 0;
      for (let i = 0; i < points.length; i++) {
        if (points[i] === 1) {
          l1 += Number(labels[i]);
          c1 += 1;
        } else {
          l2 += Number(labels[i]);
          c2 += 1;
        }
      }
      return { 1: func.round2(l1 / c1), 2: func.round2(l2 / c2) };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/RallyTimesOnScore.vue